import React from 'react'

const Card = ({ children }) => (
  <div className="p-3 mb-4 bg-transparent text-gray-900 rounded-lg">{children}</div>
)

export default Card
